import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-tabs-tab-active {
    font-weight: 600;
  }

  .ant-tabs-ink-bar {
    height: 5px !important;
    background: ${({ theme }) => theme.colors.green6};
  }

  overflow: auto;
  max-height: 800px;
  height: 100%;
`;
